import React from 'react';
import { MMLHelper } from '_common/utils/MMLHelper';
import { useEquationsContext } from './EquationsContext';

interface MathComponentProps {
  mml: string | undefined;
  testId?: string;
}

const MathComponent: React.FC<MathComponentProps> = ({ mml, testId }) => {
  const { setIsValid } = useEquationsContext();

  if (!mml) {
    return null;
  }

  return (
    <div
      ref={(ref) => {
        if (ref) {
          try {
            ref.innerHTML = '';
            MMLHelper.appendMMLToElement(mml, ref);
          } catch (error) {
            setIsValid(false);
          }
        }
      }}
      data-testid={testId}
    />
  );

  return null;
};

export default MathComponent;
